import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-beige py-20 px-4" data-id="element-28">
      <div className="max-w-3xl mx-auto" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border-2 border-gold/30 p-8 md:p-12 rounded-sm shadow-xl text-center relative" data-id="element-30">
          <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-white p-2 rounded-full border-2 border-gold/30" data-id="element-31">
            <div className="bg-gold/10 p-4 rounded-full" data-id="element-32">
              <ShieldCheck className="w-10 h-10 text-gold" data-id="element-33" />
            </div>
          </div>

          <h2 className="text-2xl md:text-4xl font-serif text-charcoal mt-8 mb-6" data-id="element-34">
            Garantía de Satisfacción de 7 Días
          </h2>

          <p className="text-lg text-brown leading-relaxed" data-id="element-35">
            Si después de leer el blueprint sientes que no es para ti o que no
            te acerca más a tu meta de libertad, te devolvemos tu dinero al
            100%. Sin preguntas y con la misma paz con la que empezamos.{' '}
            <strong className="text-charcoal" data-id="element-36">El riesgo es todo mío.</strong>
          </p>
        </motion.div>
      </div>
    </section>;
}